import React, { useEffect, useState, useRef, useMemo } from "react";
import useDropdownStore from "../store/useDropdownStore";
import useFilterStore from "../store/useFilterStore";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import {
  LotSize,
  propertystatus,
  eitheroroptions,
} from "../store/Dropdowndata";
import { useNavigate } from "react-router-dom";
import SearchFields from "./SearchFields";

/** Sale listings: exclude "Other Residential" (code 4) from property type options — matches Search.js */
const SALE_EXCLUDED_PROPERTY_TYPE_CODE = "4";

const Home = () => {
  const { metadata, fetchMetadata } = useDropdownStore();
  const { filterData, storeFilterData } = useFilterStore();

  const salePropertyTypeOptions = useMemo(() => {
    if (!metadata || !Array.isArray(metadata)) return [];
    return metadata.filter(
      (pt) => String(pt.code) !== SALE_EXCLUDED_PROPERTY_TYPE_CODE
    );
  }, [metadata]);

  const excludeOtherResidentialFromSalePropertyTypes = (types) => {
    if (!types) return null;
    if (Array.isArray(types)) {
      const filtered = types.filter(
        (pt) => pt && String(pt.code) !== SALE_EXCLUDED_PROPERTY_TYPE_CODE
      );
      return filtered.length > 0 ? filtered : null;
    }
    if (String(types.code) === SALE_EXCLUDED_PROPERTY_TYPE_CODE) return null;
    return types;
  };
  const [autocompletevalue, setautocompleteValue] = useState("");
  const [selectedMinprice, setSelectedMinprice] = useState(null);
  const [selectedMaxprice, setSelectedMaxprice] = useState(null);
  const [selectedBeds, setSelectedBeds] = useState(null);
  const [selectedBaths, setSelectedBaths] = useState(null);
  const [selectedLotSize, setSelectedLotSize] = useState(null);
  const [selectedPropertyStatus, setSelectedPropertyStatus] = useState(null);
  const [selectedPropertyType, setSelectedPropertyType] = useState(null);
  const [selectedforeclosure, setSelectedforeclosure] = useState(null);
  const [selectedshortsale, setSelectedshortsale] = useState(null);
  const [selectedpoolpreference, setSelectedpoolpreference] = useState(null);
  const [propertyminage, setpropertyminage] = useState("");
  const [propertymaxage, setpropertymaxage] = useState("");
  const [livingareamin, setlivingareamin] = useState("");
  const [livingareamax, setlivingareamax] = useState("");
  const [separatediningroom, setseparatediningroom] = useState(false);
  const [eatinkitchen, seteatinkitchen] = useState(false);
  const [counterislandseating, setcounterislandseating] = useState(false);
  const [breakfastnook, setbreakfastnook] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedsorting, setselectedsorting] = useState("7");
  const navigate = useNavigate();

  // Refs for dropdown controls to manage visibility
  const propertyTypeRef = useRef(null);
  const propertyStatusRef = useRef(null);
  const foreclosureRef = useRef(null);
  const shortSaleRef = useRef(null);
  const poolRef = useRef(null);
  const lotSizeRef = useRef(null);
  // Refs for InputNumber controls
  const propertyMinAgeRef = useRef(null);
  const propertyMaxAgeRef = useRef(null);
  const livingAreaMinRef = useRef(null);
  const livingAreaMaxRef = useRef(null);
  const [openControlId, setOpenControlId] = useState(null);

  // Function to close all dropdowns except the one being opened
  const handleControlShow = (controlId) => {
    if (openControlId && openControlId !== controlId) {
      // Close the previously open control
      const refs = {
        propertytype: propertyTypeRef,
        constructionstatus: propertyStatusRef,
        foreclosure: foreclosureRef,
        shortsale: shortSaleRef,
        poolpreference: poolRef,
        lotsize: lotSizeRef,
      };
      const prevRef = refs[openControlId];
      if (prevRef && prevRef.current && prevRef.current.hide) {
        prevRef.current.hide();
      }
    }
    setOpenControlId(controlId);
  };

  // Function to handle focus on InputNumber or checkbox - closes other controls
  const handleInputFocus = (controlId) => {
    if (openControlId && openControlId !== controlId) {
      // Close the previously open control
      const refs = {
        propertytype: propertyTypeRef,
        constructionstatus: propertyStatusRef,
        foreclosure: foreclosureRef,
        shortsale: shortSaleRef,
        poolpreference: poolRef,
        lotsize: lotSizeRef,
      };
      const prevRef = refs[openControlId];
      if (prevRef && prevRef.current && prevRef.current.hide) {
        prevRef.current.hide();
      }
    }
    setOpenControlId(controlId);
  };

  // Function to handle blur on InputNumber or checkbox
  const handleInputBlur = (controlId) => {
    // Small delay to allow for click events on checkboxes
    setTimeout(() => {
      if (openControlId === controlId) {
        setOpenControlId(null);
      }
    }, 100);
  };

  // Function to clear open control when one closes
  const handleControlHide = (controlId) => {
    if (openControlId === controlId) {
      setOpenControlId(null);
    }
  };

  useEffect(() => {
    if (!metadata) {
      fetchMetadata(); // Fetch only once
    }
  }, [metadata]);

  // if (loading) return <p>Loading filters...</p>;
  // if (error) return <p>Error loading filters: {error}</p>;

  useEffect(() => {
    // const toggleBtn = document.getElementById("toggleFilters");
    // const filterPanel = document.getElementById("filterPanel");
    // const toggleBtn1 = document.getElementById("toggleFilters1");
    // const filterPanel1 = document.getElementById("filterPanel1");
    // const toggleBtn2 = document.getElementById("toggleFilters2");
    // const filterPanel2 = document.getElementById("filterPanel2");
    // const toggleBtn3 = document.getElementById("toggleFilters3");
    // const filterPanel3 = document.getElementById("filterPanel3");
    // const toggleBtn4 = document.getElementById("toggleFilters4");
    // const filterPanel4 = document.getElementById("filterPanel4");

    // // Show/hide function
    // function togglePanel(button, panel) {
    //   button.addEventListener("click", (e) => {
    //     e.stopPropagation(); // prevent closing when button is clicked
    //     closeAllPanelsExcept(panel);
    //     panel.style.display =
    //       panel.style.display === "block" ? "none" : "block";
    //   });
    //   panel.addEventListener("click", (e) => {
    //     e.stopPropagation(); // prevent closing when clicking inside the panel
    //     setIsVisible(true);
    //   });
    // }

    // // Close all panels
    // function closeAllPanelsExcept(currentPanel = null) {
    //   const panels = [
    //     filterPanel,
    //     filterPanel1,
    //     filterPanel2,
    //     filterPanel3,
    //     filterPanel4,
    //   ];
    //   panels.forEach((p) => {
    //     if (p && p !== currentPanel) {
    //       p.style.display = "none";
    //     }
    //   });
    // }
    // // Set up toggle for each pair
    // if (toggleBtn && filterPanel) togglePanel(toggleBtn, filterPanel);
    // if (toggleBtn1 && filterPanel1) togglePanel(toggleBtn1, filterPanel1);
    // if (toggleBtn2 && filterPanel2) togglePanel(toggleBtn2, filterPanel2);
    // if (toggleBtn3 && filterPanel3) togglePanel(toggleBtn3, filterPanel3);
    // if (toggleBtn4 && filterPanel4) togglePanel(toggleBtn4, filterPanel4);

    // Close panels when clicking outside
    const handleDocumentClick = function (event) {
      // If the click is on the More Options button, do not close the panel
      const moreOptionsBtn = document.getElementById("toggleFilters");
      if (moreOptionsBtn && moreOptionsBtn.contains(event.target)) {
        return;
      }
      
      // Check if click is on an InputNumber or checkbox
      const inputNumberIds = ["propertyminage", "propertymaxage", "livingareamin", "livingareamax"];
      const checkboxIds = ["separatediningroom", "eatinkitchen", "counterislandseating", "breakfastnook"];
      const clickedElement = event.target;
      const isInputNumber = inputNumberIds.some(id => {
        const element = document.getElementById(id);
        return element && (element === clickedElement || element.contains(clickedElement));
      });
      const isCheckbox = checkboxIds.some(id => {
        const element = document.getElementById(id);
        return element && element === clickedElement;
      });
      
      // If clicking on an InputNumber or checkbox, don't close controls
      if (isInputNumber || isCheckbox) {
        return;
      }
      
      // Close all open controls when clicking outside
      if (openControlId) {
        const refs = {
          propertytype: propertyTypeRef,
          constructionstatus: propertyStatusRef,
          foreclosure: foreclosureRef,
          shortsale: shortSaleRef,
          poolpreference: poolRef,
          lotsize: lotSizeRef,
        };
        const currentRef = refs[openControlId];
        // If it's a dropdown/multiselect, use hide() method
        if (currentRef && currentRef.current && currentRef.current.hide) {
          currentRef.current.hide();
        }
        // Clear state for all control types
        setOpenControlId(null);
      }
      
      setIsVisible(false); // Hide the main filter panel when clicking outside
    };
    
    document.addEventListener("click", handleDocumentClick);
    
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };

    // const filterButtons = document.querySelectorAll(".filter-buttons .btn");
    // filterButtons.forEach((button) => {
    //   button.addEventListener("click", () => {
    //     // If this button is already active, remove active class from all
    //     if (button.classList.contains("active")) {
    //       filterButtons.forEach((btn) => btn.classList.remove("active"));
    //     } else {
    //       // Otherwise remove from others and set this one as active
    //       filterButtons.forEach((btn) => btn.classList.remove("active"));
    //       button.classList.add("active");
    //     }
    //   });
    // });
  }, [openControlId]);
  const populateFromFilterData = () => {
    if (filterData && Object.keys(filterData).length > 0) {
      setautocompleteValue(filterData.searchtext || "");
      setSelectedMinprice(filterData.minprice || null);
      setSelectedMaxprice(filterData.maxprice || null);
      setSelectedBeds(filterData.beds || null);
      setSelectedBaths(filterData.baths || null);
      setSelectedLotSize(filterData.lotSize || null);
      setSelectedPropertyStatus(filterData.propertyStatus || null);
      setSelectedPropertyType(
        excludeOtherResidentialFromSalePropertyTypes(filterData.propertyType || null)
      );
      setSelectedforeclosure(filterData.foreclosure || null);
      setSelectedshortsale(filterData.shortsale || null);
      setSelectedpoolpreference(filterData.poolpreference || null);
      setpropertyminage(filterData.propertyminage || "");
      setpropertymaxage(filterData.propertymaxage || "");
      setlivingareamin(filterData.livingareamin || "");
      setlivingareamax(filterData.livingareamax || "");
      setseparatediningroom(!!filterData.separatediningroom);
      seteatinkitchen(!!filterData.eatinkitchen);
      setcounterislandseating(!!filterData.counterislandseating);
      setbreakfastnook(!!filterData.breakfastnook);
      setselectedsorting(filterData.sortby || "7"); // Default to "7" if not set
    }
  };
  // Function called from SearchFields component
  const handleSearchFieldsSubmit = (searchFieldsData) => {
    // Update local state with values from SearchFields
    setautocompleteValue(searchFieldsData.searchtext);
    setSelectedMinprice(searchFieldsData.minprice);
    setSelectedMaxprice(searchFieldsData.maxprice);
    setSelectedBeds(searchFieldsData.beds);
    setSelectedBaths(searchFieldsData.baths);

    // Build full form data combining SearchFields data with more options
    const formData = {
      searchtext: searchFieldsData.searchtext,
      minprice: searchFieldsData.minprice,
      maxprice: searchFieldsData.maxprice,
      beds: searchFieldsData.beds,
      baths: searchFieldsData.baths,
      propertyType: excludeOtherResidentialFromSalePropertyTypes(selectedPropertyType),
      propertyStatus: selectedPropertyStatus,
      foreclosure: selectedforeclosure,
      shortsale: selectedshortsale,
      poolpreference: selectedpoolpreference,
      propertyminage: propertyminage,
      propertymaxage: propertymaxage,
      livingareamin: livingareamin,
      livingareamax: livingareamax,
      lotSize: selectedLotSize,
      separatediningroom: separatediningroom,
      eatinkitchen: eatinkitchen,
      counterislandseating: counterislandseating,
      breakfastnook: breakfastnook,
      PageNumber: 1,
      sortby: selectedsorting,
    };
    storeFilterData(formData);
    navigate("/search");
  };

  // Function to serialize and submit the search form (used by More Options Apply button)
  const handleSearchSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    
    // Preserve the searchtext format - Search.js can handle both object and string formats
    // If autocompletevalue is an object, keep it as is; if it's a string, use it directly
    const searchTextValue = autocompletevalue;
    
    const formData = {
      searchtext: searchTextValue,
      minprice: selectedMinprice,
      maxprice: selectedMaxprice,
      beds: selectedBeds,
      baths: selectedBaths,
      propertyType: excludeOtherResidentialFromSalePropertyTypes(selectedPropertyType),
      propertyStatus: selectedPropertyStatus,
      foreclosure: selectedforeclosure,
      shortsale: selectedshortsale,
      poolpreference: selectedpoolpreference,
      propertyminage: propertyminage,
      propertymaxage: propertymaxage,
      livingareamin: livingareamin,
      livingareamax: livingareamax,
      lotSize: selectedLotSize,
      separatediningroom: separatediningroom,
      eatinkitchen: eatinkitchen,
      counterislandseating: counterislandseating,
      breakfastnook: breakfastnook,
      PageNumber: 1,
      sortby: selectedsorting,
    };
    storeFilterData(formData);
    // Check filterData value after storing

    navigate("/search"); // Redirect to Search component
  };

  // useEffect(() => {
  //   console.log("filterData updated in Home.js:", filterData);
  // }, [filterData]);

  useEffect(() => {
    populateFromFilterData();
    // eslint-disable-next-line
  }, [filterData]);
  // Helper function to normalize filter values - set "No Preference" or "Any" to null
  const normalizeFilterValue = (value) => {
    if (!value) return null;
    
    // For arrays (MultiSelect)
    if (Array.isArray(value)) {
      const filtered = value.filter(item => {
        if (!item) return false;
        // Check if item has code "-1" or name is "No Preference" or "Any"
        return item.code !== "-1" && item.name !== "No Preference" && item.name !== "Any";
      });
      return filtered.length > 0 ? filtered : null;
    }
    
    // For single values (Dropdown)
    if (typeof value === 'object' && value !== null) {
      // Check if code is "-1" or name is "No Preference" or "Any"
      if (value.code === "-1" || value.name === "No Preference" || value.name === "Any") {
        return null;
      }
    }
    
    return value;
  };
  return (
    <div>
      <form id="search-form" type="POST" onSubmit={handleSearchSubmit}>
        <section className="banner-section">
          <div className="search-section d-flex justify-content-center align-items-center align-content-center">
            <picture>
              <source
                srcSet="/banner/banner.webp"
                type="image/webp"
              />
              <img
                src="/banner/banner.png"
                id="search_banner"
                alt="Find your home - Move to Happy"
                className="hero-bannerhome"
                fetchPriority="high"
              />
            </picture>
            <div className="search-box text-center">
              <div className="icon-wrapper mb-3">
                <img
                  src={require("../assets/image/banner/search.png")}
                  alt="Search Icon"
                  className="search-icon"
                />
              </div>
              <h2 className="text-white fw-bold">
                Start Your Search
                <br />
                and Move to Happy!
              </h2>
              {/* form start */}
              <div className="mt-4">
                <SearchFields
                  onSearch={handleSearchFieldsSubmit}
                  showMoreOptionsButton={true}
                  showSearchButton={true}
                  onMoreOptionsClick={() => setIsVisible(!isVisible)}
                  isMoreOptionsVisible={isVisible}
                  onSearchTextChange={(value) => {
                    // Sync SearchFields' search text with Home.js state
                    setautocompleteValue(value);
                  }}
                  initialValues={{
                    searchtext: autocompletevalue,
                    minprice: selectedMinprice,
                    maxprice: selectedMaxprice,
                    beds: selectedBeds,
                    baths: selectedBaths,
                  }}
                />
              </div>
              {/* form end */}
            </div>
             {isVisible && (
          <div
            className="filter-panel filterPanel1"
            id="filterPanel"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
          >
            <div className="row g-3">
              <div className="col-md-4">
                <div className="custom-field">
                  <div className="custom-label" id="input_l">
                    PROPERTY TYPE
                  </div>
                  <div className="card flex justify-content-center">
                    <MultiSelect
                      ref={propertyTypeRef}
                      id="propertytype"
                      style={{ zIndex: 9999 }}
                      value={selectedPropertyType}
                      onChange={(e) => setSelectedPropertyType(normalizeFilterValue(e.value))}
                      options={salePropertyTypeOptions}
                      optionLabel="name"
                      placeholder="No Preference"
                      maxSelectedLabels={3}
                      className="w-full md:w-20rem"
                      selectAll={true}
                      selectAllLabel="Select All"
                      onShow={() => handleControlShow("propertytype")}
                      onHide={() => handleControlHide("propertytype")}
                    />
                  </div>
                  {/* <select className="custom-select">
                <option>No Preference</option>
              </select> */}
                </div>
                <div className="custom-field">
                  <div className="custom-label" id="input_l">
                    STATUS
                  </div>
                  <div className="card flex justify-content-start">
                    <Dropdown
                      ref={propertyStatusRef}
                      id="constructionstatus"
                      value={selectedPropertyStatus}
                      onChange={(e) => setSelectedPropertyStatus(normalizeFilterValue(e.value))}
                      options={propertystatus}
                      optionLabel="name"
                      placeholder="No Preference"
                      className="w-full md:w-14rem"
                      onShow={() => handleControlShow("constructionstatus")}
                      onHide={() => handleControlHide("constructionstatus")}
                    />
                  </div>
                </div>
                <div className="custom-field">
                  <div className="custom-label" id="input_l">
                    FORECLOSURE
                  </div>
                  <div className="card flex justify-content-start">
                    <Dropdown
                      ref={foreclosureRef}
                      id="foreclosure"
                      value={selectedforeclosure}
                      onChange={(e) => setSelectedforeclosure(normalizeFilterValue(e.value))}
                      options={eitheroroptions}
                      optionLabel="name"
                      placeholder="No Preference"
                      className="w-full md:w-14rem"
                      onShow={() => handleControlShow("foreclosure")}
                      onHide={() => handleControlHide("foreclosure")}
                    />
                  </div>
                </div>
                {/* <div className="d-flex"> */}
                <div className="custom-field">
                  <div className="custom-label">
                    SHORT
                    <br /> SALE
                  </div>
                  <div className="card flex justify-content-start">
                    <Dropdown
                      ref={shortSaleRef}
                      id="shortsale"
                      value={selectedshortsale}
                      onChange={(e) => setSelectedshortsale(normalizeFilterValue(e.value))}
                      options={eitheroroptions}
                      optionLabel="name"
                      placeholder="No Preference"
                      className="w-full md:w-14rem"
                      onShow={() => handleControlShow("shortsale")}
                      onHide={() => handleControlHide("shortsale")}
                    />
                  </div>
                </div>
                {/* </div> */}
              </div>

              <div className="col-md-4 p-0">
                <div className="custom-field">
                  <div className="custom-label">PROPERTY AGE</div>
                  <div className="d-flex flex-grow-1" style={{ gap: "8px" }}>
                    <div style={{ flex: "1", minWidth: 0, borderRight: "1px solid #ced4da", paddingRight: "8px" }}>
                      <InputNumber
                        ref={propertyMinAgeRef}
                        inputId="propertyminage"
                        placeholder="Min"
                        value={propertyminage}
                        onValueChange={(e) => setpropertyminage(e.value)}
                        onFocus={() => handleInputFocus("propertyminage")}
                        onBlur={() => handleInputBlur("propertyminage")}
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div style={{ flex: "1", minWidth: 0, paddingLeft: "8px" }}>
                      <InputNumber
                        ref={propertyMaxAgeRef}
                        inputId="propertymaxage"
                        placeholder="Max"
                        value={propertymaxage}
                        onValueChange={(e) => setpropertymaxage(e.value)}
                        onFocus={() => handleInputFocus("propertymaxage")}
                        onBlur={() => handleInputBlur("propertymaxage")}
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="custom-field">
                  <div className="custom-label">
                    LIVING AREA <br />
                    (SQ. FT.)
                  </div>
                  <div className="d-flex flex-grow-1" style={{ gap: "8px" }}>
                    <div style={{ flex: "1", minWidth: 0, borderRight: "1px solid #ced4da", paddingRight: "8px" }}>
                      <InputNumber
                        ref={livingAreaMinRef}
                        inputId="livingareamin"
                        placeholder="Min"
                        value={livingareamin}
                        onValueChange={(e) => setlivingareamin(e.value)}
                        onFocus={() => handleInputFocus("livingareamin")}
                        onBlur={() => handleInputBlur("livingareamin")}
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div style={{ flex: "1", minWidth: 0, paddingLeft: "8px" }}>
                      <InputNumber
                        ref={livingAreaMaxRef}
                        inputId="livingareamax"
                        placeholder="Max"
                        value={livingareamax}
                        onValueChange={(e) => setlivingareamax(e.value)}
                        onFocus={() => handleInputFocus("livingareamax")}
                        onBlur={() => handleInputBlur("livingareamax")}
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="custom-field">
                  <div className="custom-label" id="input_l">
                    POOL
                  </div>
                  <div className="card flex justify-content-start">
                    <Dropdown
                      ref={poolRef}
                      id="poolpreference"
                      value={selectedpoolpreference}
                      onChange={(e) => setSelectedpoolpreference(normalizeFilterValue(e.value))}
                      options={eitheroroptions}
                      optionLabel="name"
                      placeholder="No Preference"
                      className="w-full md:w-14rem"
                      onShow={() => handleControlShow("poolpreference")}
                      onHide={() => handleControlHide("poolpreference")}
                    />
                  </div>
                </div>
                <div className="custom-field">
                  <div className="custom-label">LOT SIZE</div>
                  <div className="card flex justify-content-start">
                    <Dropdown
                      ref={lotSizeRef}
                      id="lotsize"
                      value={selectedLotSize}
                      onChange={(e) => setSelectedLotSize(normalizeFilterValue(e.value))}
                      options={LotSize}
                      optionLabel="name"
                      placeholder="No Preference"
                      className="w-full md:w-14rem"
                      onShow={() => handleControlShow("lotsize")}
                      onHide={() => handleControlHide("lotsize")}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <label id="Dining">DINING/KITCHEN</label>
                <div className="checkbox-group mt-2">
                  <label>
                    <input
                      id="separatediningroom"
                      name="separatediningroom"
                      type="checkbox"
                      checked={separatediningroom}
                      onChange={(e) => {
                        setseparatediningroom(e.target.checked);
                      }}
                      onClick={() => handleInputFocus("separatediningroom")}
                    />
                    Separate Dining Room
                  </label>
                  <label>
                    <input
                      id="eatinkitchen"
                      name="eatinkitchen"
                      type="checkbox"
                      checked={eatinkitchen}
                      onChange={(e) => seteatinkitchen(e.target.checked)}
                      onClick={() => handleInputFocus("eatinkitchen")}
                    />
                    Eat-In Kitchen
                  </label>
                  <label>
                    <input
                      id="counterislandseating"
                      name="counterislandseating"
                      type="checkbox"
                      checked={counterislandseating}
                      onChange={(e) =>
                        setcounterislandseating(e.target.checked)
                      }
                      onClick={() => handleInputFocus("counterislandseating")}
                    />
                    Counter/Island Seating
                  </label>
                  <label>
                    <input
                      id="breakfastnook"
                      name="breakfastnook"
                      type="checkbox"
                      checked={breakfastnook}
                      onChange={(e) => setbreakfastnook(e.target.checked)}
                      onClick={() => handleInputFocus("breakfastnook")}
                    />
                    Breakfast Nook
                  </label>
                </div>
                <button
                  className="apply-btn mt-4"
                  type="button"
                  onClick={handleSearchSubmit}
                >
                  APPLY
                </button>
              </div>
            </div>
          </div>
        )}
          </div>
        </section>
       
      </form>
    </div>
  );
};

export default Home;
